import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="sm:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-film-line text-xl"></i>
            </span>
            <span className="font-heading font-black text-lg">
              诱人的女员工<span className="text-accent-500">hd</span>
            </span>
          </div>
          <p className="text-sm text-background-300 leading-relaxed max-w-md">
            专注影视作品介绍与推荐的资讯门户，为用户整理最新电影、电视剧的剧情简介、演员资料与相关资讯，
            帮助你更快找到想看的作品。
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-background-50 mb-4">
            <Link to="/" className="cursor-pointer">快速导航</Link>
          </h4>
          <ul className="flex flex-col gap-2 text-sm text-background-300">
            <li><Link to="/" className="hover:text-accent-400 cursor-pointer transition-colors">首页</Link></li>
            <li><Link to="/category/movie" className="hover:text-accent-400 cursor-pointer transition-colors">电影专区</Link></li>
            <li><Link to="/category/tv" className="hover:text-accent-400 cursor-pointer transition-colors">电视剧专区</Link></li>
            <li><Link to="/search" className="hover:text-accent-400 cursor-pointer transition-colors">搜索影视</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-background-50 mb-4">
            <Link to="/about" className="cursor-pointer">关于本站</Link>
          </h4>
          <ul className="flex flex-col gap-2 text-sm text-background-300">
            <li><Link to="/about" className="hover:text-accent-400 cursor-pointer transition-colors">网站介绍</Link></li>
            <li><Link to="/about" className="hover:text-accent-400 cursor-pointer transition-colors">联系我们</Link></li>
            <li><Link to="/about" className="hover:text-accent-400 cursor-pointer transition-colors">使用声明</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-400">
          <span>© {new Date().getFullYear()} 诱人的女员工hd影视专区 · 本站内容仅用于影视资讯展示与演示</span>
          <span>本站不提供在线播放与下载功能</span>
        </div>
      </div>
    </footer>
  );
}